import { render, staticRenderFns } from "./ViolationWarn.vue?vue&type=template&id=f4015318&scoped=true&"
import script from "./ViolationWarn.vue?vue&type=script&lang=js&"
export * from "./ViolationWarn.vue?vue&type=script&lang=js&"
import style0 from "./ViolationWarn.vue?vue&type=style&index=0&id=f4015318&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4015318",
  null
  
)

export default component.exports